import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActionService } from '../action/action.service';
import { ApiService } from '../api/api.service';
import { PreviousRouteService } from '../routing/previous-route.service';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    public userSubject: BehaviorSubject<any>;
    public userValue: Observable<any>;

    constructor(
        private router: Router,
        private actionService: ActionService,
        private previousRouteService: PreviousRouteService,
        private api: ApiService,
    ) {

        this.userSubject = new BehaviorSubject<any>(localStorage.getItem('user'));
        this.userValue = this.userSubject.asObservable();

    }

    /**
     * Fetches current user
     */
    public get currentUserValue() {

        return this.userSubject.value;

    }

    /**
     * Login user by setting the user localstraoge and then resolving the behaviorsubject
     * @param data 
     */
    public login(data, msg = '', firstTime = false) {

        if (msg) {
            localStorage.setItem('snackMsg', msg);
        } else {
            localStorage.setItem('snackMsg', '');
        }

        if (data?.Result?.StudentKey?._text) {
            this.fetchStudent(data?.Result?.StudentKey?._text);
        }



        data.first_name = '';
        localStorage.setItem('user', JSON.stringify(data));
        localStorage.setItem('first_name', '');
        this.userSubject.next(data);

        let goTo = '/home';
        goTo = this.previousRouteService.getPreviousUrl();

        let goToCartOnFirstTimeLogin = localStorage.getItem('go_to_cart_on_login');
        if (goToCartOnFirstTimeLogin && goToCartOnFirstTimeLogin == 'yes') {
            goTo = '/cart';
        }
        localStorage.setItem('go_to_cart_on_login', '');

        //For if the user is updating their email address!
        let goToAccountFirstTimeLogin = localStorage.getItem('go_to_account_on_login');
        if (goToAccountFirstTimeLogin && goToAccountFirstTimeLogin == 'yes') {
            goTo = '/my-account';
        }
        localStorage.setItem('go_to_account_on_login', '');


        if (goTo) {
            this.router.navigateByUrl(goTo);
        } else {
            this.router.navigateByUrl('/home');
        }

    }


    async fetchStudent(StudentKey) {

        if (StudentKey) {
            await this.api.get_student_no_email(StudentKey)
                .subscribe(res => {
                    console.log(res);
                    if (res?.Result?.Student.Email?._text) {
                        localStorage.setItem('user_email', res?.Result?.Student.Email?._text);
                    }
                }, (err) => {

                });

        }
    }

    /**
     * Logout by removing user from local storage and setting current user to null
     */
    logout() {

        this.actionService.setAction({
            action: "clear_cart",
            data: null
        });

        localStorage.clear();
        this.userSubject.next(null);

    }

}
